import { SelectionRect } from '@/types/selection';

export const DEFAULT_SELECTION_LAYER_ATTRIBUTES: SelectionRect = {
  /* Temp approach to get around selecting coords on the pitch with a x and y of 0 */
  x: -1,
  y: -1,
  width: 0,
  height: 0,
};
